// Credit to https://codepen.io/seoh/pen/PPZYQy for the general functionality

import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-md/lib/Buttons";

const formattedSeconds = (sec) =>
  Math.floor(sec / 60) +
    ":" +
  ("0" + sec % 60).slice(-2);


class Stopwatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsElapsed: 0,
      laps: [],
      lastClearedIncrementer: null
    };
    this.incrementer = null;
  }

  componentDidMount () {
    const {tickOnMount} = this.props;
    if(tickOnMount) {
      this.handleStartClick();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {onChange} = this.props;
    const {secondsElapsed} = this.state;
    if(prevState.secondsElapsed !== secondsElapsed) {
      onChange(secondsElapsed);
    }
  }

  componentWillUnmount() {
    this.handleStopClick();
  }

  handleStartClick() {
    const start = Date.now();
    this.incrementer = setInterval( () => {
      // below can't be used based changes below...will have to be re-think if needed
      // if(!this.props.paused)
        this.setState({secondsElapsed: Math.floor((Date.now() - start) / 1000)});
    }, 1000);

    if(this.props.onStarted)
      this.props.onStarted();
  }

  handleStopClick() {
    clearInterval(this.incrementer);
    this.setState({
      lastClearedIncrementer: this.incrementer
    });
    if(this.props.onStopped)
      this.props.onStopped();
  }

  render() {
    const {whiteFont, className} = this.props;
    return (
      <div className={`stopwatch${className ? ` ${className}` : ""} `}>
        <h1 className={`stopwatch-timer${whiteFont ? " white-font" : ""} `}>{this.props.label}{formattedSeconds(this.state.secondsElapsed)}</h1>

        {this.props.hideStopStart ||
          (this.state.secondsElapsed === 0 ||
            this.incrementer === this.state.lastClearedIncrementer
            ? <Button
                  primary
                  raised
                  onClick={this.handleStartClick.bind(this)}
                  children="Resume"
                  className="m-t-10 save start-btn"
                  style={{width: "100%"}}
              />
            : <Button
                  primary
                  raised
                  onClick={this.handleStopClick.bind(this)}
                  children="Pause"
                  className="m-t-10 save stop-btn"
                  style={{width: "100%"}}
            />  )
        }
      </div>
    );
  }
}

Stopwatch.defaultProps = {
  tickOnMount: true,
  whiteFont: false,
  paused: false,
};

Stopwatch.propTypes = {
    onStarted: PropTypes.func,
    onStopped: PropTypes.func,
    hideStopStart: PropTypes.bool,
    tickOnMount: PropTypes.bool,
    whiteFont: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    paused: PropTypes.bool,
    label: PropTypes.string,
};

export default Stopwatch;
